"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultBuildInfo = void 0;
const defaultBuildInfo = {
    commitShort: "",
    commitFull: "",
    commitURL: "",
    isCommitDirty: false,
    branch: "",
    branchURL: "",
    dateISO: "",
};
const getDefaultBuildInfo = () => (Object.assign({}, defaultBuildInfo));
exports.getDefaultBuildInfo = getDefaultBuildInfo;
//# sourceMappingURL=BuildInfo.js.map